import { TreeNode } from '../route-builder';

export const HeadCountApprovalModule = {
  segment: 'people-planner',
  children: {
    HeadCountApprovalComponent: { segment: '' },
    HeadcountApprovalIntroductionComponent: { segment: 'introduction' },
    HeadcountApprovalTasksComponent: { segment: 'my-tasks', params: ['filter', 'openDetails'] },
    HeadcountApprovalAllRequestsComponent: { segment: 'all-requests', params: ['filter'] },
    HeadcountApprovalPlannedRequestsComponent: { segment: 'planned', params: ['filter'] },

    HeadcountOverviewMyTeamComponent: { segment: 'list-view' },
    HeadcountOverviewDepartmentViewComponent: { segment: 'analytics' }
  }
} as const satisfies TreeNode;
